import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Dropdown from './../Dropdown';
import check from '../assets/check.png';
import Prompt from '../Prompt';
import Disclaimer from '../Disclaimer';
import { parse } from 'query-string';
import { NavLink } from "react-router-dom";
import { withTranslation, Trans } from 'react-i18next';
import { cameraView01HullColorImageOptions } from './views/CameraView01HullColor'

class X49Hull extends Component {


    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            code: '',
            promptVisible: false,
            codeBoat: '',
            codePrompVisible: false
        };

        this.handleHullColorChange = this.handleHullColorChange.bind(this);
        this.handleCodeSubmit = this.handleCodeSubmit.bind(this);
    }

    componentDidMount() {
        const query = parse(this.props.location.search, { ignoreQueryPrefix: true });
        if (query.code !== undefined) {
            this.props.onCodeSubmitted(query.code);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }


    handleHullColorChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullColour = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleCodeSubmit() {
        let json = JSON.parse(atob(this.state.code));

        if (json[0] !== 'x49') {
            if (typeof json[0] === 'string') {
                this.setState({
                    codeBoat: json[0],
                    codePrompVisible: true
                });
            }
            return;
        }

        if (this.props.onCodeSubmitted) {
            this.props.onCodeSubmitted(this.state.code);
        }

        this.setState({ promptVisible: true });

        this.timer = setTimeout(() => {
            this.setState({ promptVisible: false });
        }, 5000);
    }

    render() {
        let imageOptions = cameraView01HullColorImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <Prompt type="info" visible={this.state.promptVisible}><Trans defaults='Info prompt: Configuration loaded' /></Prompt>
                    <Prompt type="error" visible={this.state.codePrompVisible}><Trans defaults='Error prompt: Code is for {{boat}}' values={{ boat: this.state.codeBoat }} /> <NavLink to={"/" + this.state.codeBoat + "?code=" + this.state.code}><Trans defaults='Error prompt: go there' /></NavLink></Prompt>

                    <h1><Trans defaults='Hull colourways' /></h1>

                    <Dropdown options={this.props.hullColourOptions} onChange={this.handleHullColorChange} value={this.props.configuration.HullColour} style={{maxWidth:472}} />

                    <p>
                        <img style={{border:'1px solid #c2c2c2'}} src={this.props.configuration.HullColour.preview} alt={this.props.configuration.HullColour.label} />
                    </p>

                    <h2><Trans defaults='Hull' /></h2>
                    <p><Trans defaults='X49 Hull Text' /></p>

                    <h2><Trans defaults='Keel structure' /></h2>
                    <p><Trans defaults='X49 Keel structure Text' /></p>

                    <h2><Trans defaults='Load previous configuration' /></h2>
                    <p><Trans defaults='Load previous configuration Text' /></p>
                    <button className="button" style={{ marginRight: 15 }} onClick={() => { this.setState({ expanded: !this.state.expanded }); }}><Trans defaults='Load code' /></button>
                    <div className={"expander" + (this.state.expanded ? " open" : " closed")}>
                        <p>
                            <input type="text" value={this.state.code} style={{ width: 262, verticalAlign: 'top', marginRight: 10 }} onChange={(event) => { this.setState({ code: event.target.value }); }} />
                            <button className="secondary button" onClick={this.handleCodeSubmit}><img src={check} alt="submit" /></button>
                        </p>
                    </div>
                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49Hull);


// WEBPACK FOOTER //
// ./src/X49/X49Hull.js